<div class="text-center cover d-flex" *ngIf="visible">
  <main class="cover-container w-100 m-auto">
    <img class="w-50 mb-3" src="assets/images/lexicon-white-logo-300x48.png" />
    <h1 class="h1 mb-5 text-thin">{{appTitle}}</h1>
    <div class="loading-icon-wrapper h5" *ngIf="isAccessDenied">
      <fa-icon class="me-2" [icon]="faShieldHalved"></fa-icon> Access Denied
      <p class="mt-3">You do not have sufficient permissions to access this application.</p>
    </div>
    <div class="loading-icon-wrapper h5" *ngIf="!isAccessDenied">
      <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> {{message}}
    </div>
  </main>
</div>